module.exports = __webpack_public_path__ + "static/about-img-b12632e727dbee427db15f970ef8ea4b.jpg";